export const validatePersonalInfo = (formData) => {
    const errors = {};
  
    if (!formData.prenom) errors.prenom = 'Le prénom est requis';
    if (!formData.nom) errors.nom = 'Le nom est requis';
    if (!formData.residence) errors.residence = 'La résidence est requise';
    if (!formData.email) {
      errors.email = 'L\'email est requis';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'L\'email est invalide';
    }
    if (!formData.telephone) errors.telephone = 'Le numéro de téléphone est requis';
    if (!formData.genre) errors.genre = 'Le genre est requis';
    if (!formData.dateNaissance) errors.dateNaissance = 'La date de naissance est requise';
    if (!formData.typeCarte) errors.typeCarte = 'Le type de carte est requis';
  
    return errors;
  };
  
  export const validateMedicalInfo = (formData) => {
    const errors = {};
  
    if (!formData.antecedentsMedicaux) errors.antecedentsMedicaux = 'Les antécédents médicaux sont requis';
    if (!formData.medicamentsActuels) errors.medicamentsActuels = 'Les médicaments actuels sont requis';
    if (!formData.medecinTraitant) errors.medecinTraitant = 'Le nom du médecin traitant est requis';
    if (!formData.numeroSecuriteSociale) errors.numeroSecuriteSociale = 'Le numéro de sécurité sociale est requis';
    if (!formData.nomPharmacie) errors.nomPharmacie = 'Le nom de la pharmacie est requis';
    if (!formData.adressePharmacie) errors.adressePharmacie = 'L\'adresse de la pharmacie est requise';
  
    return errors;
  };
  
  export const validateIdentificationInfo = (formData) => {
    const errors = {};
  
    if (!formData.username) errors.username = 'Le nom d\'utilisateur est requis';
    if (!formData.password) errors.password = 'Le mot de passe est requis';
    if (!formData.questionSecurite) errors.questionSecurite = 'La question de sécurité est requise';
    if (!formData.languePreferee) errors.languePreferee = 'La langue préférée est requise';
    if (!formData.notificationPreference) errors.notificationPreference = 'La préférence de notification est requise';
    if (!formData.consentement) errors.consentement = 'Le consentement est requis';
  
    return errors;
  };


//   AdminFormValidation

export const validateAdminPersonalInfo = (formData) => {
    const errors = {};
  
    if (!formData.prenom) {
      errors.prenom = "Le prénom est requis";
    }
    if (!formData.nom) {
      errors.nom = "Le nom est requis";
    }
    if (!formData.residence) {
        errors.residence = "La residence est requis";
      }
    if (!formData.email) {
      errors.email = "L'email est requis";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "L'email est invalide";
    }
    if (!formData.telephone) {
      errors.telephone = "Le numéro de téléphone est requis";
    }
    if (!formData.genre) {
      errors.genre = "Le genre est requis";
    }
    if (!formData.dateNaissance) {
      errors.dateNaissance = "La date de naissance est requise";
    }
  
    return errors;
  };
  
  export const validateAdminIdentificationInfo = (formData) => {
    const errors = {};
  
    if (!formData.username) {
      errors.username = "Le nom d'utilisateur est requis";
    }
    if (!formData.password) {
      errors.password = "Le mot de passe est requis";
    } else if (formData.password.length < 6) {
      errors.password = "Le mot de passe doit contenir au moins 6 caractères";
    }
    if (!formData.role) {
      errors.role = "Le rôle est requis";
    }
    if (!formData.permissions) {
      errors.permissions = "Les permissions sont requises";
    }
  
    return errors;
  };


//   Validation des services ou institution
export const validateServiceInfo = (formData) => {
    const errors = {};
  
    if (!formData.nomInstitution) {
      errors.nomInstitution = "Le nom de l'institution est requis";
    }
    if (!formData.adresseInstitution) {
      errors.adresseInstitution = "L'adresse de l'institution est requise";
    }
    if (!formData.email) {
      errors.email = "L'email est requis";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "L'email est invalide";
    }
    if (!formData.telephone) {
      errors.telephone = "Le numéro de téléphone est requis";
    }
    if (!formData.typeInstitution) {
      errors.typeInstitution = "Le type d'institution est requis";
    }
  
    return errors;
  };
  
  export const validateServiceIdentificationInfo = (formData) => {
    const errors = {};
  
    if (!formData.username) {
      errors.username = "Le nom d'utilisateur est requis";
    }
    if (!formData.password) {
      errors.password = "Le mot de passe est requis";
    } else if (formData.password.length < 6) {
      errors.password = "Le mot de passe doit contenir au moins 6 caractères";
    }
    if (!formData.nomContact) {
      errors.nomContact = "Le nom du contact est requis";
    }
    if (!formData.posteContact) {
      errors.posteContact = "Le poste du contact est requis";
    }
  
    return errors;
  };



  //   Validation des structures
export const validateStructureInfo = (formData) => {
  const errors = {};

  if (!formData.nomStructure) {
    errors.nomStructure = "Le nom du structure est requis";
  }
  if (!formData.adresseStructure) {
    errors.adresseStructure = "L'adresse du structure est requise";
  }
  if (!formData.email) {
    errors.email = "L'email est requis";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "L'email est invalide";
  }
  if (!formData.telephone) {
    errors.telephone = "Le numéro de téléphone est requis";
  }
  if (!formData.typeStructure) {
    errors.typeStructure = "Le type du structure est requis";
  }

  return errors;
};

export const validateStructureIdentificationInfo = (formData) => {
  const errors = {};

  if (!formData.username) {
    errors.username = "Le nom d'utilisateur est requis";
  }
  if (!formData.password) {
    errors.password = "Le mot de passe est requis";
  } else if (formData.password.length < 6) {
    errors.password = "Le mot de passe doit contenir au moins 6 caractères";
  }
  if (!formData.nomContact) {
    errors.nomContact = "Le nom du contact est requis";
  }
  if (!formData.posteContact) {
    errors.posteContact = "Le poste du contact est requis";
  }

  return errors;
};



export const validateCategorie = (formData) => {
  const errors = {};

  if (!formData.name) {
    errors.name = "Le nom de catégorie est requis";
  }
}

export const validateCardInfo = (formData) => {
  const errors = {};

  if (!formData.cardNo) {
    errors.cardNo = "Le numéro de carte est requis";
  }
  if (!formData.createDate) {
    errors.createDate = "La date de création est requise";
  }
  if (!formData.expiryDate) {
    errors.expiryDate = "La date d'expiration est requise";
  }
  if (!formData.balance) {
    errors.balance = "Le solde est requis";
  } else if (isNaN(formData.balance) || formData.balance < 0) {
    errors.balance = "Le solde doit être un nombre positif";
  }
  if (!formData.totalRemaining) {
    errors.totalRemaining = "Le total restant est requis";
  } else if (isNaN(formData.totalRemaining) || formData.totalRemaining < 0) {
    errors.totalRemaining = "Le total restant doit être un nombre positif";
  }
  if (!formData.status) {
    errors.status = "Le statut est requis";
  } else if (typeof formData.status !== 'boolean') {
    errors.status = "Le statut doit être un booléen";
  }
  if (!formData.categoryId) {
    errors.categoryId = "L'ID de catégorie est requis";
  } else if (isNaN(formData.categoryId) || formData.categoryId < 0) {
    errors.categoryId = "L'ID de catégorie doit être un nombre positif";
  }

  return errors;
};

export const validatePartnerInfo = (formData) => {
  const errors = {};

  if (!formData.name) errors.name = 'Le nom est requis';
  if (!formData.serviceId) errors.serviceId = 'Le service est requis';
  if (!formData.email) {
    errors.email = 'L\'email est requis';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'L\'email est invalide';
  }


  return errors;
};

export const validateWarrantieData = (formData) => {
  const errors = {};

  if (!formData.name) errors.name = 'Le nom est obligatoire';
  if (!formData.coverage) errors.coverage = 'Le taux de couverture est obligatoire';
  if (!formData.limit) errors.limit = 'Le plafond est obligatoire';
  if (!formData.limitType) errors.limitType = 'Le type limite est obligatoire';
  if (!formData.serviceId) errors.serviceId = 'Le service est obligatoire';

  return errors;
};